<template>
  <div v-if="categories" class="webshop-categories">
    <v-toolbar style="position: relative;">
      <div
        class="ml-md-7 mr-4 search__tab"
        @click="openSearch"
      >
        <v-icon id="trigger-button" color="white">search</v-icon>
      </div>
      <v-divider
        v-if="categories.length"
        style="background-color: white; opacity: 0.5; height: 100%"
        vertical
      />
      <v-tabs
        v-if="categories.length"
        :class="{ categories__inactive: !$route.params.categoryFirst }"
        :value="activeTab"
        background-color="primary"
        class="pr-4"
        dark
      >
        <v-tab @click="goToHome()">
          <v-icon color="white">home</v-icon>
        </v-tab>
        <v-tab
          v-for="(category, index) in categories"
          :key="index"
          @click="goToCategory(category)"
        >
          {{ category.title }}
        </v-tab>
      </v-tabs>
    </v-toolbar>
  </div>
</template>

<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins.js";
import { waitFor } from "vue-wait";
import { debounce } from "lodash-es";

export default {
  mixins: [webshopMixins],
  data: () => ({
    windowHeight: window.innerHeight,
    windowSize: { x: window.innerWidth, y: window.innerHeight },
  }),
  methods: {
    openSearch() {
      this.$emit("search-event", true);
      this.$emit("overlay-event", true);
    },
    setWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    executeSearch: debounce(function(string) {
      this.showAll = false;
      waitFor(`loading webshop getProductsBySearchText`, async function() {
        await this.$store.dispatch("webshop/getProductsBySearchText", {
          chainId: this.$route.params.chainId,
          searchText: string,
        });
      }).apply(this);
    }, 300),

    goToProductDetails(product) {
      this.closeSearch();
      this.$router
        .push({
          name: "webshopChainProductDetails",
          params: {
            productId: product.idBase64,
            productTitle: product.urlSafeTitle || "product",
          },
        })
        .catch(() => {});
    },

    goToHome() {
      this.$router
        .push({
          name: "webshopChain",
          params: {
            chainId: this.$route.params.chainId,
          },
        })
        .catch(() => {});
    },

    activateTabCategory() {
      this.$nextTick(() => {
        const tab = this.$refs["tab-" + this.$route.query.category];
        if (!this.searchText && tab && tab.length) tab[0].toggle();
      });
    },

    searchBlurEvent() {
      //   this.search = this.searchText && this.searchText.length > 1;
      this.activateTabCategory();
    },

    searchGoToCategory(category) {
      let mainCategory = this.categories.find((x) =>
        x.children.map((x) => x.title).includes(category.title)
      );
      this.closeSearch();
      this.$router
        .push({
          name: "webshopChainProductsMainCategories",
          params: { categoryFirst: mainCategory.urlSafeTitle },
          query: {
            [category.webshopCategoryId ? "category" : "mCategory"]:
              category.webshopCategoryId || category.urlSafeName,
          },
        })
        .catch(() => {});
    },

    searchGoToBrandSerie(brandSerie) {
      this.closeSearch();
      this.$router
        .push({
          name: "webshopChainProductsCategories",
          query: {
            serie: [brandSerie.id.Base64Guid],
            brand: [brandSerie.brandId.Base64Guid],
          },
        })
        .catch(() => {});
    },

    async goToCategory(category) {
      this.$eventBus.$emit("webshop-main-category-update", true);
      this.closeSearch();
      await this.$router
        .push({
          name: "webshopChainProductsMainCategories",
          params: { categoryFirst: category.urlSafeTitle },
          query: null,
        })
        .catch(() => {});
      this.$eventBus.$emit("webshop-main-category-update", false);
    },

    closeSearch() {
      this.$emit("overlay-event", false);
      this.$emit("search-event", false);
    },
  },
  computed: {
    maxSearchContainerHeight() {
      return this.$vuetify.breakpoint.mdAndUp ? 500 : this.windowHeight - 176;
    },
    searchProductsCategories() {
      return this.$store.getters["webshop/get"](
        "searchProductsCategories"
      ).filter((x) => x.count);
    },

    searchProductsBrands() {
      return this.$store.getters["webshop/get"]("searchProductsBrands");
    },

    productsSearchFilter() {
      return this.$store.getters["webshop/get"]("searchProducts");
    },

    productsSearchFilterLimit() {
      if (this.showAll || this.$vuetify.breakpoint.mdAndUp)
        return this.$store.getters["webshop/get"]("searchProducts");
      else
        return this.$store.getters["webshop/get"]("searchProducts").slice(0, 5);
    },

    activeTab() {
      return (
        this.categories.findIndex(
          (c) => this.$route.params.categoryFirst === c.urlSafeTitle
        ) + 1
      ); // to account for home tab
    },

    categoriesFiltered() {
      return this.mappedCategories.filter((x) => x.count > 0);
    },

    brandsAndSeriesFiltered() {
      let array = [];
      this.searchProductsBrands.forEach((x) => {
        let children = x.children.map(
          (y) =>
            new Object({
              ...y,
              count: this.productsSearchFilter
                .map((x) => x.serieName)
                .filter((x) => x === y.title).length,
              titleBrand: x.title,
              brandId: x.id,
            })
        );
        array.push(children);
      });
      return array.flat().filter((x) => x.count > 0);
    },
  },
  watch: {
    "$route.query.category": {
      handler(val) {
        if (parseInt(val) >= 0)
          this.$nextTick(() => {
            let tab = this.$refs["tab-" + val];
            if (tab && tab.length) tab[0].toggle();
          });
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>

.webshop-categories {
  position: sticky;
  z-index: 2;
}

.v-tabs::v-deep {
  .v-tab {
    color: white !important;
    text-transform: none;
    min-width: unset;
    font-size: 14px !important;
  }

  .v-slide-group__prev--disabled {
    display: none !important;
  }
}

.search__tab:hover {
  opacity: 0.5;
  cursor: pointer;
}

.categories__inactive::v-deep {
  .v-tabs-slider-wrapper {
    display: none;
  }
}



.v-toolbar {
  background-color: var(--v-primary-base) !important;
}

.v-input::v-deep .v-input__append-inner {
  margin: 15px 0;
}

.card {
  display: flex;
  min-width: 100%;
  overflow-x: auto;
}

.card::-webkit-scrollbar {
  display: none;
}

.card--content {
  min-width: 200px;
  margin: 5px;
  padding: 5px;
  color: #34495e;
}
</style>
